import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getGfcPageSliceContent = createAsyncThunk('/gfcTexts/content', async () => {
	const response = await axios.post(`${API_URL}/getGFCText`);
    console.log(response.data);
	return response;
})

export const gfcPageTextSlice = createSlice({
    name: 'gfcTexts',
    initialState: {
        isLoading: false,
        gfcTexts : []
    },
    reducers: {
    },
    extraReducers: {
		[getGfcPageSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getGfcPageSliceContent.fulfilled]: (state, action) => {
			state.gfcTexts = action.payload.data
			state.isLoading = false
		},
		[getGfcPageSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default gfcPageTextSlice.reducer